<template>
   <form class="form-login" @submit.prevent="submit">

           <div class="lines">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
            </div>

        <div class="row">
            <div class="col-md-12 text-center mb-4">
                <img alt="logo" style="width: 58px; hight: 58px" :src="settings.image_path" class="theme-logo">
            </div>

            <div class="col-md-12">
              <!-- <div class="alert alert-danger" v-if="error ==1">{{errorShow}}</div> -->
              <label for="" class="" v-show="0">ناريخ الطلب</label>
                <input type="text" v-show="0" class="form-control mb-4" placeholder="تاريخ الطلب" v-model="cred.request_date" required readonly >
                <label for="inputName" class="">اسم ولي الأمر</label>
                <input type="text" id="inputName" class="form-control mb-4" placeholder="اسم ولي الأمر" v-model="cred.name" required >
                <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['name']">
                  {{ getErrors['name'][0] }}
                </div>

                 <label for="inputName1" class="">اسم الطالب</label>
                <input type="text" id="inputName1" class="form-control mb-4" placeholder="اسم الطالب" v-model="cred.child_name" required >
                <div class="invalid-feedback" :style="getErrors['child_name'] ? 'display: block' : 'display: none;'"  v-if="getErrors['child_name']">
                  {{ getErrors['child_name'][0] }}
                </div>

                <label for="inputEmail" class="">رقم الجوال</label>
                <input type="text" id="inputEmail" class="form-control mb-4" maxlength="10" placeholder="رقم الجوال" v-model="cred.mobile" required >
                <div class="invalid-feedback" :style="getErrors['mobile'] ? 'display: block' : 'display: none;'"  v-if="getErrors['mobile']">
                  {{ 'من فضلك قم بإدخال رقم الجوال بشكل صحيح' }}
                </div>

                <label for="inputPassword" class="">المرحلة الدراسية</label>
                <treeselect class="mb-4" :options="stages" v-model="cred.stage_id" @select="getGroups" :multiple="false"/>
                <div class="invalid-feedback" :style="getErrors['stage_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stage_id']">
                  {{ getErrors['stage_id'][0] }}
                </div>


                <label for="inputPassword" class="">الصف</label>
                <treeselect class="mb-4" :options="groups" v-model="cred.group_id" @select="setStage" :multiple="false"/>
                <div class="invalid-feedback" :style="getErrors['group_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['group_id']">
                  {{ getErrors['group_id'][0] }}
                </div>

                <div class="checkbox d-flex justify-content-between mb-4 mt-3">
                    <div class="custom-control custom-checkbox mr-3">
                        <input type="checkbox" class="custom-control-input" v-model="cred.remember_me" id="customCheck1">
                        <label class="custom-control-label"  for="customCheck1">تذكرنى</label>
                    </div>
                    <!-- <div class="forgot-pass">
                        <a href="user_pass_recovery_1.html">Forgot Password?</a>
                    </div> -->
                </div>
                <button class="btn btn-lg btn-gradient-danger btn-block btn-rounded mb-4 mt-5" v-if="!isRequested" type="submit">تسجيل طلب</button>
            </div>
        </div>
    </form>
</template>

<script>
import router from '@/router'
import store from '@/store'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,

  },
  data() {
    return {
      groups: [],
      stages: [],
      settings: {},
      cred: {
        mobile: '',
        password: '',
        child_name: '',
        group_id: '',
        stage_id: '',
        name: '',
        remember_me: true
      },
      errors: {},
      errorShow: '',
      authError: '',
      error: 0,
      isRequested: false,
    }
  },
  created(){
    this.getSettings();
  },
  methods: {
    getSettings(){

      this.$baseApi.get('/parent-settings?register=1').then((response) => {
        let res = response.data.data;
        if (response.data.code === 200) {
          this.settings = response.data.data;
          this.cred.request_date = this.settings.current_date;
          this.groups = this.settings.groups;
          this.stages = this.settings.stages;
        }
      }).catch((error) => {

      });

    },
    getGroups(val){
      this.cred.group_id = '';
      this.$baseApi.get('/parent-settings?register=1&option=group&i='+val.id).then((response) => {
        let res = response.data.data;
        if (response.data.code === 200) {
          this.groups = res.groups;
        }
      }).catch((error) => {

      });

    },
    setStage(val){
       this.cred.stage_id = '';
      this.$baseApi.get('/parent-settings?register=1&option=stage&s='+val.id).then((response) => {
        let res = response.data.data;
        if (response.data.code === 200) {
          this.cred.stage_id = res.stage_id;
        }
      }).catch((error) => {

      });
    },
    isAppleDevice() {
      return /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
    },

localStorageAvailable() {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
},

storeData(key, value) {
  let dataToStore;

  // Check if value is an object (JSON) or a simple string
  if (typeof value === 'object' && value !== null) {
    dataToStore = JSON.stringify(value); // Convert JSON object to string
  } else {
    dataToStore = value; // If it's already a string, store it as is
  }

  if (this.isAppleDevice() && !this.localStorageAvailable()) {
    // Store the data in cookies for Apple devices
    document.cookie = `${key}=${dataToStore}; path=/`;
  } else {
    // Store the data in localStorage for other devices
    localStorage.setItem(key, dataToStore);
  }
},

retrieveData(key) {
  let data;

  if (this.isAppleDevice() && !this.localStorageAvailable()) {
    // Retrieve data from cookies
    const match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
    data = match ? match[2] : null;
  } else {
    // Retrieve data from localStorage
    data = localStorage.getItem(key);
  }

  try {
    // Try to parse the data as JSON
    return JSON.parse(data);
  } catch (e) {
    // If parsing fails, return the data as a string
    return data;
  }
},

    submit() {
      this.isRequested = true;
         this.error = 0;
      this.$baseApi.post('/parent-register', this.cred).then((response) => {
        let res = response.data.data;
        if (response.data.code === 200) {
          store.dispatch('SET_AUTH_USER', res.user);
          let token = {
            value: res.access_token,
            type: res.token_type,
            expires_at: res.expires_in
          };
          store.dispatch('SET_TOKEN', token);
          store.dispatch('SET_AUTH', true);
          store.dispatch('SET_PERMISSIONS', res.permissions);
          this.storeData('token', token.value);
          this.storeData("auth", JSON.stringify(res.user));
          this.$cookies.set('token', token.value);
        this.$cookies.set('role', res.user.role);
        this.$cookies.set('user', {name: res.user.name, email: res.user.email, role: res.user.role});
          location.reload();
          router.push('/dashboard');
          this.isRequested = false;

          // localStorage.setItem('parent_register', 1);
          // window.location.href = 'parent-login';
          // this.isRequested = false;
        }
      }).catch((error) => {
        this.errors = JSON.parse(JSON.stringify(error.response.data.errors));
         this.error = 1;
          this.isRequested = false;
      })

    }
  },
  computed: {
    getErrors() {
      return JSON.parse(JSON.stringify(this.errors))
    }
  },
};
</script>
